module.exports = __webpack_public_path__ + "img/coffee-beans.a6907831.svg";